import { useQuery } from '@tanstack/react-query';
import { api } from '@/shared/api/client';

export type RollupCfg = { object: string; via: string; fn: string; field: string | null };
export type ObjField = {
  key: string; label: string; type: string; required: boolean;
  options?: Array<{ value: string; label: string }> | string[];
  ref_entity?: string | null; list_visible?: boolean; display_order?: number;
  rollup?: RollupCfg | null;
};
export type ObjectDef = {
  id: string; key: string; label: string; label_plural: string;
  icon?: string | null; title_field?: string | null; fields: ObjField[];
  read_roles?: string[]; write_roles?: string[];
};

export function useCustomObjects() {
  const { data } = useQuery({ queryKey: ['custom-objects'], queryFn: () => api.get<ObjectDef[]>('/custom-objects') });
  return data || [];
}
